
















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import { SearchResultItem, SearchResult } from '@/models/QuickSearchModel';
@Component({
    components: {}
})
export default class QuickSearchResult extends Vue {
    @Prop()
    protected result!: SearchResult['items'];
    @Prop()
    protected searchUrl!: string;
    @Prop()
    protected selectedItem!: number;
    @Prop()
    protected focus!: boolean;
    constructor() {
        super();
    }
    get resultFiltered() {
        return this.result.filter(x => x.name);
    }

    private afterEnter(element: HTMLElement) {
        element.style.height = 'auto';
        element.classList.add('slide-in');
    }
    private leave(element: HTMLElement) {
        const height = getComputedStyle(element).height;

        element.style.height = height;
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = '0';
        });
    }
    private afterLeave(element: HTMLElement) {
        element.classList.remove('slide-in');
    }
}
